const pidBlock = function (robotType, blockSeparator, categorySeparator) {
    switch (robotType) {
        case 'E7':
            return `
                <category
                    name="PID"
                    id="pid"
                    colour="#64c7de"
                    secondaryColour="#64c7de">
                <block type="pid_setPidControler">
                    <value name="VALUE">
                        <shadow type="math_number">
                            <field name="NUM">0</field>
                        </shadow>
                    </value>
                </block>
                <block type="pid_setPidControlerFork">
                    <value name="KP">
                        <shadow type="math_number">
                            <field name="NUM">0</field>
                        </shadow>
                    </value>
                    <value name="KI">
                        <shadow type="math_number">
                            <field name="NUM">0</field>
                        </shadow>
                    </value>
                    <value name="KD">
                        <shadow type="math_number">
                            <field name="NUM">0</field>
                        </shadow>
                    </value>
                </block>
                <block type="pid_getPidControlResult"/>
                ${blockSeparator}
                </category>
                `;
        default:
            return `

                <category
                    name="PID"
                    id="pid"
                    colour="#64c7de"
                    secondaryColour="#64c7de">
                </category>
                `;
    }
};

export default pidBlock;
